import { render, staticRenderFns } from "./printCode.vue?vue&type=template&id=18e70c63&scoped=true&"
import script from "./printCode.vue?vue&type=script&lang=js&"
export * from "./printCode.vue?vue&type=script&lang=js&"
import style0 from "./printCode.vue?vue&type=style&index=0&id=18e70c63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e70c63",
  null
  
)

export default component.exports